import React from "react";
import { ArrowButton } from "../../components/arrow-button";

interface SamiBuhariProps {
    isVisible: boolean;
    comeBackSemaSection: Function;
}

const SamiBuhari = (props: SamiBuhariProps) => {
    return (
        <div style={{ display: props.isVisible ? "block" : "none" }}>
            <article>
                <ArrowButton onClick={props.comeBackSemaSection} />
                <h4 className="section-title">
                    MUHAMMED SAMİ BUHARİ<br />
                    (SALAMON SALMAN) <br />
                </h4>

                <p>
                    Yahudi dindar bir anne ve babanın çocuğu olarak İstanbul’da dünyaya geldim. İstanbul’da Galatasaray İlköğretim okulunda ilkokula başladım. 5. sınıfın bitirme imtihanı esnasında hocam bana bir soru sordu: ”İslam nedir?”  Soruyu duyunca o anda içimde bir şeyler hissettim. Mutlaka Allah bana söyletti. Ben de bu soruya karşılık olarak “İslam, güneş gibidir. Nasıl ki güneş doğunca bütün yıldızlar kaybolur İslam da öyle bir şeydir.” dedim.
                </p>
                <p>
                    Müteakiben ortaokulu ve liseyi de Galatasaray’da tamamladım. O yıllarda içimde dizginleyemediğim gizli bir din arayışı vardı. İstanbul’da çok seçkin bir ilim adamı olan Hahambaşı Rabin Peres’ten eğitim adım. Daha eğitimimin başında Rabin Peres bana 24 farklı Tevrat’ın olduğunu söylemişti. Hristiyanlık tarihi hakkındaki araştırmalarımda tıpkı Tevrat gibi İncil’inde birçok farklı versiyonunun mevcut olduğunu öğrendim. Hristiyanlarca çok önemli olan İznik Konsili’nde bu konuda önemli kararlar alınmış, Konsil’de 404 İncil arasından 4 İncil’e (Matta, Markos, Luka, Yuhanna) karar verilmiştir. Bu bilgiler neticesinde içimde Yahudilik ve Hristiyanlık dinine karşı bir soğuma başladı.
                </p>

                <p>
                    Bu sıralarda Sinagog’da Yahudilik üzerine mezammerlik ve hahambaşı yardımcılığı için bir okulda eğitim alıyordum. On bir sene kadar Yüksek Kaldırım’da Aşkenaz Sinagogu’nda hahambaşının yanında hem yardımcılık hem de mezammerlik yaptım.
                </p>
                <p>
                    Fakat ruhumda iman konusunda bir tedirginlik ve boşluk vardı. O zamanlar arayış içerisindeydim. Sık sık şöyle dua ederdim: “Allah’ım bana senin razı olacağın dini göster.” Çünkü dini yönden hiçbir zaman gerçek huzuru hissedememiştim. Yine bu anlardan birisinde Allah’tan bana doğru yolu göstermesi için içimden dua ettim. Duadan sonra bir süre tefekkür hâlinde bulundum. “Allah’ım senin razı olacağın dini bana göster.” diye tekrar tekrar dua ettim. Allah da bu duama icabet etti ve hak din olarak bana İslam’ı gösterdi, Elhamdulillah.
                </p>
                <p>
                    <span className="text-bold">“Amentü billahi ve melâiketihi,ve kütübihî ve rusülihî ve’l yevmi’l-âhıri ve bi’l-kaderi, hayrihî ve şerrihi mina’llâhi teâlâ ve’l-ba’sü ba’de’l mevt. Hakkun, Eşhedü en lâ ilâhe illallâh ve Eşhedü enne Muhammeden abdühû ve rasûlühü.”</span> diyerekten müslüman oldum.
                </p>
                <p>
                    <span className="text-bold">İslam’ın esasları olan Kelime-i Şahadet, Namaz, Oruç, Zekât ve Hac bana talim buyruldu. </span>
                </p>
                <p>
                    İslamî isim olarak <span className="text-bold">Muhammed Sami Buharî</span>adını aldım.
                </p>
                <p>
                    Diğer eski Yahudi dindaşlarımın da Müslüman olması için her zaman dua ediyorum.
                </p>
                <p>
                    9 yıl boyunca medresede 4 mezhebte fetva verecek ilim tahsil ettim. Hocalarım bu programı asgari olarak 12 yılda tamamlayabileceğimi söylemişlerdi. Ancak bana 9 senede tamamlamak nasip oldu, Elhamdulillah.
                </p>
                <p>
                    Allah yar ve yardımcımız olsun. Ali Yakub Baba’ya Havra’dan ve Kilise’den yüzlerce insanın İslam olmasına vesile olduğu için kendisine sonsuz hürmetlerimi sunarım.
                </p>

            </article>
        </div>
    );
}

export default SamiBuhari;